import { render } from "./AlertComponent.vue?vue&type=template&id=0599a18e&scoped=true&ts=true&lang=pug"
import script from "./AlertComponent.vue?vue&type=script&lang=ts&setup=true"
export * from "./AlertComponent.vue?vue&type=script&lang=ts&setup=true"

import "./AlertComponent.vue?vue&type=style&index=0&id=0599a18e&lang=scss&scoped=true"

import exportComponent from "/codebuild/output/src2191176947/src/lottrackr-front/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0599a18e"]])

export default __exports__